$(document).ready(function () {
    $('.minilangnavbar .dropdown-toggle').dropdown();
    if ($('#floatingSocialShare .minilangnavbar.dropdown .dropdown-menu a').length <= 1) {
        $('#floatingSocialShare .minilangnavbar.dropdown').remove();
    }

});